import styled from "styled-components";

export const ChangeData = styled.div`
  position: absolute;
  top: 0;
  right: 54px;
  font-size: 12px;
  line-height: 22px;
  color: #aaa;

  &.no-change {
    right: 65px;

    @media print {
      right: 63px;
    }
  }

  &.unit-report {
    right: 25px;

    &.no-change {
      right: 36px;

      @media print {
        right: 34px;
      }
    }
  }

  &.up {
    color: #69bf75;
  }

  &.down {
    color: #d95f63;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/SummaryReport/components/DomainScores/components/OverviewTableRow/style.js